import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_TESTS_URL;

export default {
  getPagedTests(paging) {
    return $axios.get(
      `api/v1/test/page/${paging.page}/pagesize/${paging.pageSize}`,
      { baseURL: baseUrl },
    );
  },
  getTests() {
    return $axios.get('api/v1/test', { baseURL: baseUrl });
  },
  getTestsMinimum() {
    return $axios.get('api/v1/test/minimum', { baseURL: baseUrl });
  },
  getTest(id) {
    return $axios.get(`api/v1/test/${id}`, { baseURL: baseUrl });
  },
  removeTest(id) {
    return $axios.delete(`api/v1/test/${id}`, { baseURL: baseUrl });
  },
  getTestResult(id, size) {
    return $axios.get(`api/v1/test/${id}/result/${size}`, { baseURL: baseUrl });
  },
  generateReport(id) {
    return $axios.get(`api/v1/test/${id}/report`, {
      baseURL: baseUrl,
      responseType: 'blob',
    });
  },
  generateTeamListReport(id, size) {
    return $axios.get(`api/v1/test/${id}/report/teamlist/${size}`, {
      baseURL: baseUrl,
      responseType: 'blob',
    });
  },
  startTest(test) {
    return $axios.post('api/v1/test', test, { baseURL: baseUrl });
  },
  createTest(test) {
    return $axios.post('api/v1/test/create', test, { baseURL: baseUrl });
  },
  extendTest(test) {
    return $axios.put(`api/v1/test/${test.id}`, test, { baseURL: baseUrl });
  },
  submitTest(result) {
    return $axios.post(
      `api/v1/test/${result.testId}/student/${result.studentId}`,
      result,
      { baseURL: baseUrl },
    );
  },
  resetTest(result) {
    return $axios.post(
      `api/v1/test/${result.testId}/student/${result.studentId}/reset`,
      {},
      { baseURL: baseUrl },
    );
  },
  getStudents(group) {
    return $axios.get(`api/v1/test/${group.id}/students`, { baseURL: baseUrl });
  },
};



// WEBPACK FOOTER //
// ./src/api/tests.js